import { addDays, isAfter, isBefore, startOfWeek, subSeconds } from 'date-fns';
import { MarketLocation, ProductService } from 'generated/graphql';

export const ONE_HOUR_MILLISECONDS = 15 * 60 * 1000 * 4;
export const FOUR_HOURS_MILLISECONDS = ONE_HOUR_MILLISECONDS * 4;

export enum Direction {
  Up = 'ArrowUp',
  Down = 'ArrowDown',
  Left = 'ArrowLeft',
  Right = 'ArrowRight',
}

export enum Breakpoints {
  SM = 640,
  MD = 768,
  LG = 1024,
  XL = 1280,
}

export function DetectBrowserDevice() {
  return /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    window.innerWidth < Breakpoints.SM
    ? 'Mobile'
    : 'Desktop';
}

export const getIntervalFromWindowSize = (date: Date | number, firstLoad?: boolean) => {
  const width = window.innerWidth;
  let length: number;

  if (width < Breakpoints.SM) length = 1;
  else if (width < Breakpoints.MD) length = 3;
  else if (width < Breakpoints.LG) length = 2;
  else if (width < Breakpoints.XL) length = 4;
  else {
    length = 7;
    if (firstLoad) {
      const weekStart = startOfWeek(date, { weekStartsOn: 1 });
      return {
        start: weekStart,
        end: addDays(weekStart, length),
      };
    }
  }

  return {
    start: date,
    end: addDays(date, length),
  };
};

export function hasDevices(marketLocation: MarketLocation) {
  return !!marketLocation.machines.some((machine) => machine.devices.length > 0);
}

export const isProductServiceReleased = (productService: ProductService, date: Date) => {
  const releaseStart = productService.begin?.toLocaleString();
  const releaseEnd = productService.end?.toLocaleString();
  return releaseStart && isAfter(date, subSeconds(releaseStart, 1)) && (!releaseEnd || isBefore(date, releaseEnd));
};
